export default "__VITE_ASSET__Dbm8kk6I__"